export class AppSettings {
    public static API_ENDPOINT = 'http://localhost:8080/civilregistrationServer';
    //public static API_ENDPOINT = 'http://192.168.1.130:8080/civilRegistrationAppointmentServer';
    public static PORTAL_ENDPOINT = 'http://64.215.200.244:8880/';
}
